import saveVotingFile from "./saveVotingFile";
import deleteVotingFile from "./deleteVotingFile";

const checkFiles = async (savedVoting, updatedVoting) => {
	if (updatedVoting.file.fileList) {
		for (const file of updatedVoting.file.fileList) {
			if (file.originFileObj) {
				await saveVotingFile(file.originFileObj, savedVoting.id);
			}
			if (file instanceof File) {
				await saveVotingFile(file, savedVoting.id);
			}
		}
	}
	if (savedVoting.attachments) {
		for (const savedFile of savedVoting.attachments) {
			if (
				!updatedVoting.file.fileList.find((file) => savedFile.id === file.id)
			) {
				await deleteVotingFile(savedVoting.id, savedFile.id);
			}
		}
	}
};
export default checkFiles;
